export const resolveTimeZone = (timeZone) => {
  if (timeZone) return timeZone;
  if (typeof Intl === "undefined") return "UTC";
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export const getTimeParts = (date, timeZone) => {
  const formatter = new Intl.DateTimeFormat("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: resolveTimeZone(timeZone),
  });

  const parts = formatter.formatToParts(date);

  const hourPart = parts.find((part) => part.type === "hour");
  const minutePart = parts.find((part) => part.type === "minute");

  return {
    hour: hourPart ? Number(hourPart.value) : 0,
    minute: minutePart ? Number(minutePart.value) : 0,
  };
};

export const formatTimeString = (
  date,
  timeZone,
  timeFormat = "24h",
  { omitMinutesWhenZero = false } = {}
) => {
  const resolvedZone = resolveTimeZone(timeZone);
  const { minute } = getTimeParts(date, resolvedZone);

  const shouldOmitMinutes = omitMinutesWhenZero && minute === 0;

  const formatter = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: shouldOmitMinutes ? undefined : "2-digit",
    hour12: timeFormat === "12h",
    timeZone: resolvedZone,
  });

  return formatter.format(date);
};

export const formatDateString = (date, timeZone, options) => {
  const resolvedZone = resolveTimeZone(timeZone);
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: resolvedZone,
    ...options,
  });
  return formatter.format(date);
};
